import css from 'styled-jsx/css';

const styles = css`.auth-dialog-card{max-width:600px;border-radius:8px;background:#fff;padding:16px 24px;margin:16px auto}.auth-dialog-card :global(.base-input){margin:8px 0}@media screen and (max-width: 767px){.auth-dialog-card{max-width:330px}}`;

export default styles;